import { useFormContext } from 'react-hook-form';
import { FILTER_SECTIONS, Filter } from '@anytag/shared-molecules';
import {
  AgeField,
  FollowerField,
  PostPriceField,
  TTCMStatusField,
  AudienceDemographics,
  InfluencerStatusField,
  RegionAndProvinceField,
  InfluencerCategoryField,
  TalentAgencyPartnerField,
  EngagementFollowersAndViewsRateField
} from '../../shared';
import { AdvancedFilterDefaultProps } from '../../schemaTypes';
import { defaultTiktokInfluencersFormValues, TiktokInfluencersFilterFormValues } from '../schemaTypes';

export const AdvancedFilter = ({ count, onSubmit, isTtcmCampaign, isEngagementPage }: AdvancedFilterDefaultProps) => {
  const { reset, getValues } = useFormContext<TiktokInfluencersFilterFormValues>();

  const values = getValues();

  const handleClear = () => {
    reset({
      ...defaultTiktokInfluencersFormValues,
      // Basic filter
      keyword: values.keyword,
      genders: values.genders,
      countryIds: values.countryIds
    });
  };

  return (
    <Filter.MoreFilterPopover
      count={count}
      onClear={handleClear}
      onSubmit={onSubmit}
      items={[
        {
          value: FILTER_SECTIONS.InfluencerAttributes,
          title: FILTER_SECTIONS.InfluencerAttributes,
          node: (
            <>
              <AgeField />
              <InfluencerStatusField />
              {isEngagementPage && isTtcmCampaign ? <TTCMStatusField /> : null}
              <TalentAgencyPartnerField />
              <InfluencerCategoryField />
              <RegionAndProvinceField />
            </>
          )
        },
        {
          value: FILTER_SECTIONS.PerformanceFilter,
          title: FILTER_SECTIONS.PerformanceFilter,
          node: (
            <>
              <FollowerField />
              <EngagementFollowersAndViewsRateField />
              <PostPriceField />
            </>
          )
        },
        {
          value: FILTER_SECTIONS.Audiences,
          title: 'Audience Demographics',
          node: <AudienceDemographics />
        }
      ]}
    />
  );
};
